// extracted by mini-css-extract-plugin
export default {"mobile-nav":"MobileNav_mobile-nav__PQP8q"};